module.exports = __webpack_public_path__ + "img/aston-form.ff597be0.jpg";